import { lazy, Suspense } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import { PermissionUtils } from 'utils'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const SearchRequirementResultsRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "SearchRequirementResults" */ 'modules/Search/pages/SearchRequirementResults'
    )
)
export const SearchLibraryResultsRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "SearchLibraryResults" */ 'modules/Search/pages/SearchLibraryResults'
    )
)

const SearchRouting = () => {
  const requirementsDenied = PermissionUtils.requirementsDenied()
  const libraryDenied = PermissionUtils.libraryDenied()
  const searchRoute = libraryDenied ? routes.searchRequirements : routes.searchLibrary
  return (
    <Suspense fallback={<RouteChangeProgress />}>
      <Switch>
        <PrivateRoute
          exact
          path={routes.searchLibrary}
          component={SearchLibraryResultsRoute}
          disabled={libraryDenied}
        />
        <PrivateRoute
          exact
          path={routes.searchRequirements}
          component={SearchRequirementResultsRoute}
          disabled={requirementsDenied}
        />

        <Redirect path='*' to={searchRoute} />
      </Switch>
    </Suspense>
  )
}

export default SearchRouting
